import { z } from 'zod'

import { ChannelIdZod } from '../channels/channel-zod'
import { DateZod } from '../common'

export const BaseDashboardAlertZod = z.object({
  timestamp: DateZod,
  deleteAt: DateZod,
  regionId: z.string(),
  eveningId: z.number(),
})

export const TransportRequestDashboardAlertEventZod = z.enum(['customerCancel', 'teamCancel', 'teamUpdateDestination'])
export type TransportRequestDashboardAlertEvent = z.infer<typeof TransportRequestDashboardAlertEventZod>

export const TransportRequestDashboardAlertZod = BaseDashboardAlertZod.extend({
  type: z.literal('transportRequest'),
  transportRequestId: z.string(),
  transportRequestPiloteId: z.number(),
  event: TransportRequestDashboardAlertEventZod,
})
export type TransportRequestDashboardAlert = z.infer<typeof TransportRequestDashboardAlertZod>

export const TeamMessageDashboardAlertZod = BaseDashboardAlertZod.extend({
  type: z.literal('teamMessage'),
  teamId: z.string(),
  teamNumber: z.number(),
  hasText: z.boolean().optional(),
  hasPicture: z.boolean().optional(),
  hasAudio: z.boolean().optional(),
})
export type TeamMessageDashboardAlert = z.infer<typeof TeamMessageDashboardAlertZod>

export const ChannelMessageDashboardAlertZod = BaseDashboardAlertZod.extend({
  type: z.literal('channelMessage'),
  channelId: ChannelIdZod,
  messageId: z.string(),
  sender: z.enum(['volunteer', 'admin']),
  senderId: z.string(),
  senderName: z.string(),
  teamNumber: z.number().optional(),
  textExcerpt: z.string(),
})
export type ChannelMessageDashboardAlert = z.infer<typeof ChannelMessageDashboardAlertZod>

export const DashboardAlertZod = z.discriminatedUnion('type', [
  TransportRequestDashboardAlertZod,
  TeamMessageDashboardAlertZod,
  ChannelMessageDashboardAlertZod,
])
export type DashboardAlert = z.infer<typeof DashboardAlertZod>
